import './auth.css';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../__common/env';

export default function AuthLayout({ title, subtitle, content, isBack }) {
    const navigate = useNavigate();
    return (
        <div className="flex">
            <div className=" h-[100vh] auth-img-container ">
                <img
                    src={`${API_BASE_URL}/assets/img/auth-bg.jpg`}
                    className="w-full h-full "
                    alt=""
                />
            </div>
            <div className=" relative h-[100vh]  p-[16px] auth-form-container   ">
                <div
                    className="absolute top-[16px] left-[16px] cursor-pointer "
                    onClick={() => navigate('/')}>
                    <img
                        src={`${API_BASE_URL}/assets/logo/logo.svg`}
                        alt="Logo"
                        className=" w-auto"
                    />
                </div>
                <div className=" h-full flex items-center justify-center flex-col ">
                    <div className="w-[420px] xl:w-[400px] lg:w-[360px]">
                        {isBack && isBack}
                        <div className="flex flex-col justify-start">
                            <h1 className="text-[18px] font-medium text-theme-icon-color font-favorit mb-[4px]">
                                {title}
                            </h1>
                            <p className="text-[14px] font-medium text-[#5B5F5D] font-favorit">
                                {subtitle}
                            </p>
                        </div>
                        <div className="mt-[16px]">{content}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
